import useBranding from "@/hooks/useBranding";
import { LayoutDashboard, CalendarDays, Trophy, Send, Bot, LogOut, Globe, Coins } from "lucide-react";

const TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "fixtures", label: "Calendario & Pronostici", icon: CalendarDays },
  { id: "standings", label: "Classifica", icon: Trophy },
  { id: "telegram", label: "Broadcast & Bot", icon: Send },
  { id: "gold", label: "Oro & BTC", icon: Coins },
];

export default function Header({ tab, setTab, user, onLogout }) {
  const { name, username } = useBranding();
  return (
    <header className="sticky top-0 z-50 bg-slate-950/80 backdrop-blur-xl border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex flex-col md:flex-row md:items-center gap-3 md:justify-between">
        <div data-testid="header-logo" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[var(--gold)] text-slate-950 grid place-items-center">
            <Bot size={22} strokeWidth={2.5} />
          </div>
          <div>
            <div data-testid="brand-name" className="whitespace-nowrap font-display text-xl xl:text-2xl font-extrabold uppercase leading-none">{name || "…"}</div>
            <div className="text-[11px] font-mono text-slate-400 tracking-wider">{username ? `@${username}` : "AI PREDICTION ENGINE"}</div>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              data-testid={`nav-tab-${id}`}
              onClick={() => setTab(id)}
              className={`flex items-center gap-2 whitespace-nowrap px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                tab === id ? "bg-slate-800 text-[var(--gold)]" : "text-slate-400 hover:text-white hover:bg-slate-900"
              }`}
            >
              <Icon size={16} /> {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a data-testid="public-site-link" href="/" target="_blank" rel="noreferrer" className="btn btn-ghost py-2" title="Sito pubblico"><Globe size={16} /></a>
          <button data-testid="logout-button" title={user?.email} onClick={onLogout} className="btn btn-ghost py-2"><LogOut size={16} /> Esci</button>
        </div>
      </div>
    </header>
  );
}
